import React from "react";
import { connect } from "react-redux";
import MicroModal from "micromodal";
import { Tooltippy } from "../actions/Tippy";
import {
  removeItemFromListQuarentineCallQueue,
  TransferirChamadaEmFila,
} from "../actions";
import Checkbox from "../components/manager-section/CheckboxIng/CheckboxIng";
import {
  SendSocketTransferCallMonitorIn,
  RequestCallParkTransferSocket,
  transferCallOnQuarentine,
} from "../actions/websocket";
import { ReactComponent as TRANSFERICON } from "../build/images/icons/transfer-client-icon.svg";
import { ReactComponent as TRANSFERICON2 } from "../build/images/icons/transfer-client-icon2.svg";
import { ReactComponent as Search } from "../build/images/teams/search-normal.svg";
import { ReactComponent as ArrowDown } from "../build/images/arrow_down.svg";
import _ from "lodash";
import { ReactComponent as Arrow } from "../build/images/account-arrow-right.svg";
import DEFAULT from "../build/images/user.svg";

let isAddUserSupervisor = true;

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    TransferirChamada: (
      agent,
      scriptid,
      cdrid,
      mediaid,
      iduser,
      quarentineInfo
    ) => {
      if (!!quarentineInfo) {
        transferCallOnQuarentine(
          quarentineInfo.infoUsers,
          quarentineInfo.contactId,
          agent.iduser
        );
        dispatch(
          removeItemFromListQuarentineCallQueue(
            quarentineInfo.standbyId,
            quarentineInfo.cdrId,
            quarentineInfo.idAtendimento
          )
        );
      } else {
        dispatch(
          TransferirChamadaEmFila(agent, scriptid, cdrid, mediaid, iduser)
        );
      }
    },
  };
};

const mapStateToProps = (state) => {
  return {
    UserGroups: state.groups,
    InfoUsers: state.informationusers,
    UsersAgents: state.agents,
    AtdSimult: state.atdsimult,
    IPCurrent: state.ipcurrent,
    TransferQueue: state.transferqueue,
  };
};

class TransferClientModalEquipes extends React.Component {
  constructor(props) {
    var storageGroup = localStorage.getItem("atendance_filter_group") || [];
    if (storageGroup.length !== 0) {
      storageGroup = storageGroup.split(",").map(Number);
    }

    var storageState = localStorage.getItem("atendance_filter_state") || [];
    if (storageState.length !== 0) {
      storageState = storageState.split(",");
    }

    super(props);
    this.state = {
      isVisibleFilter: false,
      keyGen: storageGroup,
      auxkeyGen: storageGroup,
      keyGan: storageState,
      auxkeyGan: storageState,
      marked: "Marcar Todos",
      checked: false,
      groups: [],
      agents: [],
      agentsinicial: [],
      expandAgent: [],
      showtransfer: "atendentes",
      atdsimult: [],
      filterAgent: "",
    };
  }

  ChangeVisibleFilter(e) {
    e.preventDefault();
    this.setState({ isVisibleFilter: !this.state.isVisibleFilter });
  }

  changeAgent(e, teste) {
    this.setState({ filterAgent: e.target.value });
    if (e.target.value != "") {
      this.setState({ keyGan: [] });
    }
    if (e.target.value === "") {
      this.setState({ keyGan: this.state.auxkeyGan });
    }
  }

  filterGroup(e, idgroup) {
    let filtersgroupstorage = [];
    if (e.target.checked) {
      this.setState({
        keyGen: this.state.keyGen.concat([idgroup]),
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.concat([idgroup]),
      });
      filtersgroupstorage = this.state.keyGen.concat([idgroup]);
    } else {
      this.setState({
        keyGen: this.state.keyGen.filter(function (val) {
          return val != idgroup;
        }),
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.filter(function (val) {
          return val != idgroup;
        }),
      });
      filtersgroupstorage = this.state.keyGen.filter(function (val) {
        return val != idgroup;
      });
      this.setState({ marked: "Marcar Todos" });
      this.setState({ checked: false });
    }
    localStorage.setItem("atendance_filter_group", filtersgroupstorage);
  }

  filterGroupAll(e, usergroups) {
    var usergroups = usergroups.groups;
    var teste = [];
    if (e.target.checked) {
      this.setState({ checked: true });
      this.setState({ marked: "Desmarcar Todos" });
      var myCheckbox1 = document.getElementById("groups" + "0");
      myCheckbox1.checked = true;
      for (let i = 0; i < usergroups.length; i++) {
        teste.push(usergroups[i].id);
        var myCheckbox = document.getElementById("groups" + usergroups[i].id);
        myCheckbox.checked = true;
      }
      this.setState({
        keyGen: teste,
      });
    } else {
      this.setState({ marked: "Marcar Todos" });
      this.setState({ checked: false });
      var myCheckbox1 = document.getElementById("groups" + "0");
      myCheckbox1.checked = false;
      usergroups.map((groups) => {
        var myCheckbox = document.getElementById("groups" + groups.id);
        myCheckbox.checked = false;
      });
      this.setState({ keyGen: [] });
    }
  }

  filterState(e, status) {
    let filterstatestorage = [];
    if (e.target.checked) {
      filterstatestorage = this.state.keyGan.concat([status]);
      if (status === "AT")
        filterstatestorage = filterstatestorage.concat(["ATOS"]);
      this.setState({
        keyGan: filterstatestorage,
      });
      this.setState({
        auxkeyGan: filterstatestorage,
      });
    } else {
      filterstatestorage = this.state.keyGan.filter(function (val) {
        return val != status;
      });
      if (status === "AT")
        filterstatestorage = filterstatestorage.filter(function (val) {
          return val != "ATOS";
        });
      this.setState({
        keyGan: filterstatestorage,
      });
      this.setState({
        auxkeyGan: filterstatestorage,
      });
    }
    localStorage.setItem("atendance_filter_state", filterstatestorage);
  }

  TransferAgentMonitor(e, user, agent, UsersAgents) {
    const {
      dashboardMonitor,
      dashboardQueue,
      setInfoTransfer,
      setMonitorDash,
      infoQueue,
      onTransferCampaign,
      quarentineInfo = false,
    } = this.props;

    if (dashboardMonitor) {

      SendSocketTransferCallMonitorIn(
        user.id,
        localStorage.getItem("idcdr"),
        agent.iduser,
        agent.iduser,
        localStorage.getItem("serverid"),
        localStorage.getItem("usermon"),
        UsersAgents,
        localStorage.getItem("telcliente")
      );
      setInfoTransfer && setInfoTransfer(true);
      setMonitorDash && setMonitorDash(false);
      onTransferCampaign && onTransferCampaign();
    } else {
      this.props.TransferirChamada(
        agent,
        infoQueue.scriptid,
        infoQueue.cdrid,
        infoQueue.mediaid,
        user.id,
        quarentineInfo
      );
      if (dashboardQueue) {
        setMonitorDash(false);
      }
    }

    localStorage.setItem("idcdr", false);
    localStorage.setItem("serverid", false);
    localStorage.setItem("usermon", false);
    localStorage.setItem("mediaidTransfer", false);

    MicroModal.close("modal__transferir__chamada");
  }

  closeModal(modal) {
    const { dashboardMonitor, dashboardQueue, setMonitorDash } = this.props;
    if (dashboardMonitor || dashboardQueue) {
      setMonitorDash(false);
    }
    localStorage.setItem("idcdr", false);
    localStorage.setItem("serverid", false);
    localStorage.setItem("usermon", false);
    localStorage.setItem("mediaidTransfer", false);
    MicroModal.close(modal);
  }

  renderPopover2 = (e, UserGroups, InfoUsers, TransferQueue, UsersAgents) => (
    <div
      className="modal__container queue-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal__transferir__chamada"
      id="popover-check-friend"
    >
      <div className="popover">
        <header className="popover__header">
          <h2 className="modal__title" id="modal__transferir__title">
            Transferir para outro atendente
          </h2>
          <button
            onClick={(e) => {
              e.stopPropagation();
              this.closeModal("modal__transferir__chamada");
            }}
            className="modal__close"
            aria-label="Close modal"
            data-micromodal-close
          ></button>
        </header>
        <main
          className="popover__body popover__body--full-width modal__content"
          id="modal__transferir__chamada"
        >
          <div className="modal__filters">
            <div className="full-search">
              <input
                type="text"
                name="client-search"
                id="client-search"
                onChange={(event) => this.changeAgent(event, "teste")}
                placeholder="Pesquisar..."
              />
              <Search />
            </div>
            <div
              className={
                this.state.isVisibleFilter
                  ? "select with-icons with-footer-actions active"
                  : "select with-icons with-footer-actions"
              }
            >
              <button
                type="button"
                data-pausa="Atendimento Presencial Cliente"
                onClick={this.ChangeVisibleFilter.bind(this)}
              >
                Filtros <ArrowDown className={"options-filters__icon"} />
              </button>
              <div className="options">
                <ul style={{ maxHeight: "270px" }}>
                  {/* <li>
                    <input
                      type="radio"
                      defaultChecked
                      name="filterGroup"
                      id="filterGroup"
                    />
                    <label htmlFor="filterGroup">Grupo</label>
                  </li>
                  <li>
                    <hr></hr>
                  </li> */}
                  <li>
                    <Checkbox
                      typeCheck="defaultChecked"
                      defaultChecked={
                        this.state.keyGan.findIndex(function (val) {
                          return val === "LV";
                        }) !== -1
                          ? true
                          : false
                      }
                      name="filtro1"
                      onChange={(event) => this.filterState(event, "LV")}
                      id="filtro1"
                    />{" "}
                    <label htmlFor="filtro1">Usuários Disponíveis</label>
                  </li>
                  <li>
                    <Checkbox
                      typeCheck="defaultChecked"
                      defaultChecked={
                        this.state.keyGan.findIndex(function (val) {
                          return val === "AT";
                        }) !== -1
                          ? true
                          : false
                      }
                      name="filtro3"
                      onChange={(event) => this.filterState(event, "AT")}
                      id="filtro3"
                    />{" "}
                    <label htmlFor="filtro3">Usuários em Atendimento</label>
                  </li>
                  <li>
                    <Checkbox
                      typeCheck="defaultChecked"
                      name="filtro4"
                      defaultChecked={
                        this.state.keyGan.findIndex(function (val) {
                          return val === "BQ";
                        }) !== -1
                          ? true
                          : false
                      }
                      onChange={(event) => this.filterState(event, "BQ")}
                      id="filtro4"
                    />{" "}
                    <label htmlFor="filtro4">Usuários Pausados</label>
                  </li>
                  <li>
                    <Checkbox
                      typeCheck="defaultChecked"
                      name="filtro5"
                      defaultChecked={
                        this.state.keyGan.findIndex(function (val) {
                          return val === "null";
                        }) !== -1
                          ? true
                          : false
                      }
                      onChange={(event) => this.filterState(event, "null")}
                      id="filtro5"
                    />{" "}
                    <label htmlFor="filtro5">Usuários Deslogados</label>
                  </li>
                  <li>
                    <hr></hr>
                  </li>
                  <li>
                    <Checkbox
                      checked={this.state.checked}
                      name="groups0"
                      id="groups0"
                      onChange={(event) =>
                        this.filterGroupAll(event, UserGroups)
                      }
                    />{" "}
                    <label htmlFor="groups0">{this.state.marked}</label>
                  </li>
                  {this.state.groups.map((group, index) => (
                    <li key={index}>
                      <Checkbox
                        typeCheck="defaultChecked"
                        onChange={(event) => this.filterGroup(event, group.id)}
                        name={"groups" + group.id}
                        id={"groups" + group.id}
                        defaultChecked={
                          this.state.keyGen.findIndex(function (val) {
                            return val === group.id;
                          }) !== -1
                            ? true
                            : false
                        }
                      />{" "}
                      <label htmlFor={"groups" + group.id}>{group.name}</label>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div
            className={
              this.state.showtransfer
                ? "popover__clientes clts active"
                : "popover__clientes clts"
            }
          >
            <div className="list">
              <ul>
                {this.state.agents
                  .filter((agent) => {
                    if (this.props.dashboardMonitor) {
                      return true;
                    } else {
                      return agent.id !== InfoUsers.id;
                    }
                  })
                  .map((agent, index) => {
                    let typeStatus = false;
                    let voiceBlock = false;
                    if (
                      (agent.status_sip === "LV" && agent.status === "LV") ||
                      (agent.status_sip === "LV" && agent.status === "AT") ||
                      (agent.status_sip === "AT" && agent.status === "AT") ||
                      (agent.status_sip === "RV" && agent.status === "ATOS") ||
                      (agent.status_sip === "LV" && agent.status === "RV") ||
                      (agent.status_sip === "CHND" &&
                        agent.razao_bloqueio != "CHND") ||
                      (agent.status_sip === "GESTOR" &&
                        agent.razao_bloqueio != "GESTOR")
                    ) {
                      typeStatus = true;
                    }

                    const atendance = agent.jsoncall
                      ? agent.jsoncall.split("¿")
                      : [];
                    const mediaVoz = atendance.filter(
                      (vle) => vle.split("§")[0] === "1"
                    );
                    if (mediaVoz.length > 0) {
                      const voiceCall = this.props.dashboardMonitor
                        ? parseInt(localStorage.getItem("mediaidTransfer"))
                        : parseInt(this.props.infoQueue.mediaid);

                      if (voiceCall === 1) {
                        voiceBlock = true;
                      }
                    }

                    return (
                      <li key={index}>
                        <div className="img-user">
                          <img src={DEFAULT} alt="" />
                        </div>
                        <div className="data">
                          <div className="info" key={agent.id}>
                            <div className="name">{agent.username}</div>
                            <span>
                              {agent.desc_grupo} - {agent.ramal}
                            </span>
                          </div>
                          <div className="data-actions">
                            {(() => {
                              if (
                                agent.status_sip === null ||
                                agent.status === null ||
                                agent.status_sip === "null" ||
                                agent.status === "null"
                              ) {
                                return (
                                  <span className="status-tag">
                                    <div className="pausa-btn--inativo"></div>{" "}
                                    Inativo
                                  </span>
                                );
                              } else if (
                                agent.status_sip === "LV" &&
                                agent.status === "LV" &&
                                agent.razao_bloqueio !== "GESTOR"
                              ) {
                                return (
                                  <span className="status-tag">
                                    <div className="pausa-btn--livre"></div>{" "}
                                    Livre
                                  </span>
                                );
                              } else if (
                                ((agent.status_sip === "LV" &&
                                  agent.status === "AT") ||
                                  (agent.status_sip === "RV" &&
                                    agent.status === "ATOS")) &&
                                parseInt(agent.futurepause) !== 1
                              ) {
                                return (
                                  <div>
                                    <Tooltippy
                                      content={`Ocupação: ${agent.direcao} com ${agent.speaknum}`}
                                    >
                                      <span className="status-tag">
                                        <div className="pausa-btn--chmd-ativa"></div>{" "}
                                        Atendimento
                                      </span>
                                    </Tooltippy>
                                  </div>
                                );
                              } else if (
                                agent.status_sip === "AT" &&
                                agent.status === "AT" &&
                                parseInt(agent.futurepause) !== 1
                              ) {
                                return (
                                  <div>
                                    <Tooltippy
                                      content={`Em ativo com ${agent.speaknum}`}
                                    >
                                      <span className="status-tag">
                                        <div className="pausa-btn--chmd-ativa"></div>{" "}
                                        Atendimento
                                      </span>
                                    </Tooltippy>
                                  </div>
                                );
                              } else if (
                                agent.status_sip === "LV" &&
                                agent.status === "RV" &&
                                parseInt(agent.futurepause) !== 1
                              ) {
                                return (
                                  <div>
                                    <Tooltippy
                                      content={`Ocupação: ${agent.direcao} com ${agent.speaknum}`}
                                    >
                                      <span className="status-tag">
                                        <div className="pausa-btn--chmd-ativa"></div>{" "}
                                        Discando
                                      </span>
                                    </Tooltippy>
                                  </div>
                                );
                              } else if (
                                agent.status_sip === "BQ" &&
                                agent.razao_bloqueio != ""
                              ) {
                                return (
                                  <div>
                                    <Tooltippy
                                      content={`Ocupação: Pausa ${agent.razao_bloqueio}`}
                                    >
                                      <span className="status-tag">
                                        <div className="pausa-btn--pausado"></div>{" "}
                                        Pausado
                                      </span>
                                    </Tooltippy>
                                  </div>
                                );
                              } else if (parseInt(agent.futurepause) === 1) {
                                return (
                                  <div>
                                    <Tooltippy
                                      content={`Ocupação: Pausa ${agent.descfuturepause}`}
                                    >
                                      <span className="status-tag">
                                        <div className="pausa-btn--pausado"></div>{" "}
                                        Pausa Futura
                                      </span>
                                    </Tooltippy>
                                  </div>
                                );
                              } else if (
                                agent.status_sip === "CHND" &&
                                agent.razao_bloqueio != "CHND"
                              ) {
                                return (
                                  <div>
                                    <Tooltippy
                                      content={`Ocupação: Chamando ${agent.direcao} do ${agent.speaknum}`}
                                    >
                                      <span className="status-tag">
                                        <div className="pausa-btn--chmd-ativa"></div>{" "}
                                        Chamando
                                      </span>
                                    </Tooltippy>
                                  </div>
                                );
                              }
                            })()}
                            {(() => {
                              if (
                                typeStatus &&
                                !voiceBlock &&
                                parseInt(agent.futurepause) !== 1 &&
                                JSON.parse(localStorage.getItem("usermon")) !==
                                  agent.iduser
                              ) {
                                return (
                                  <div className="action">
                                    <div
                                      data-tooltip-content="Encaminhar conversa"
                                      className="tippy-default"
                                      onClick={(event) =>
                                        this.TransferAgentMonitor(
                                          event,
                                          InfoUsers,
                                          agent,
                                          UsersAgents
                                        )
                                      }
                                    >
                                      <TRANSFERICON />
                                    </div>
                                  </div>
                                );
                              } else {
                                return (
                                  <div className="action">
                                    <div
                                      data-tooltip-content="Encaminhar conversa"
                                      className="tippy-default null-default"
                                    >
                                      <TRANSFERICON />
                                    </div>
                                  </div>
                                );
                              }
                            })()}
                          </div>
                        </div>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
        </main>
      </div>
    </div>
  );

  render() {
    const {
      UserGroups,
      InfoUsers,
      UsersAgents,
      AtdSimult,
      infoQueue,
      TransferQueue,
    } = this.props;

    if (UserGroups.length != 0) {
      this.state.groups = UserGroups.groups;
    }

    this.state.atdsimult = AtdSimult;

    const list2 = this.state.atdsimult || [];
    this.state.atdsimult = _.filter(list2, (atd) => {
      let arrayAtd = [atd.cliente, atd.telefone];
      return !_.isEmpty(this.state.filterAgent)
        ? arrayAtd
            .toString()
            .toLowerCase()
            .indexOf(this.state.filterAgent.toString().toLowerCase()) > -1
        : true;
    });

    if (UsersAgents.length != 0) {
      this.state.agents = UsersAgents;
      this.state.agents = [
        ...this.state.agents,
        {
          username: InfoUsers.displayname + " - Gestor",
          id: InfoUsers.id,
          iduser: InfoUsers.id,
          id_grupo: InfoUsers.idgroup,
          status_sip: "LV",
          status: "LV",
          ramal: InfoUsers.ramal,
          desc_grupo: InfoUsers.grupo,
          duration: "00/00/0000 00:00:00-00:00:00",
          razao_bloqueio: "GESTOR",
        },
      ];
      if (this.state.keyGen != "") {
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGen.includes(agent.id_grupo)
        );
      }
      if (this.state.keyGan != "") {
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGan.includes(agent.status_sip)
        );
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGan.includes(agent.status)
        );
      }
    }

    if (this.state.filterAgent !== "") {
      const list = this.state.agents || [];
      this.state.agents = list;
      this.state.agents = _.filter(list, (agent) => {
        let arrayAgent = [
          agent.username,
          agent.desc_grupo,
          agent.ramal,
          agent.razao_bloqueio,
        ];
        return !_.isEmpty(this.state.filterAgent)
          ? arrayAgent
              .toString()
              .toLowerCase()
              .indexOf(this.state.filterAgent.toString().toLowerCase()) > -1
          : true;
      });
    }

    this.state.agents = _.orderBy(this.state.agents, ["username"], ["asc"]); // Use Lodash to sort array by 'name'

    return (
      <div
        className="modal micromodal-slide"
        id="modal__transferir__chamada__equipes"
        aria-hidden="true"
        role="dialog"
      >
        <div
          className="modal__overlay modal__overlay__modal-transfer-monitoring-dash-v2"
          tabIndex="-1"
        >
          {this.renderPopover2(
            this,
            UserGroups,
            InfoUsers,
            TransferQueue,
            UsersAgents
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransferClientModalEquipes);
